// extracted by mini-css-extract-plugin
module.exports = {"captcha":"Login_captcha__30gIQ","loginBlock":"Login_loginBlock__F6WMc"};